import React from 'react';
import './Return&Refund.css';
import SEO from '../../components/SEO';

const ReturnAndRefund = () => {
  return (
    <div className="return-refund-container">
      <SEO 
        title="Return & Refund Policy | Techie Interiors" 
        description="Learn about our return, refund, and exchange policies for Techie Interiors products and services." 
        url="https://techieinteriors.co.ke/return-policy" 
      />
      <div className="return-refund-header">
        <h1>Return & Refund Policy – Techie Interiors</h1>
      </div>

      <div className="return-refund-intro">
        <p>
          At Techie Interiors, we strive to ensure customer satisfaction with every purchase. This Return and Refund Policy outlines the conditions under which returns, exchanges, and refunds are processed.
        </p>
      </div>

      <div className="return-refund-section">
        <h2>1. General Return Policy</h2>
        <p>
          Customers may request a return within 14 days from the date of delivery, subject to the conditions outlined below:
        </p>
        <div className="conditions-box">
          <ul>
            <li>Items must be unused, undamaged, and in original condition</li>
            <li>Items must be returned in original packaging with all accessories, manuals, and invoices</li>
            <li>Proof of purchase (order number or receipt) is required</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>2. Non-Returnable Items</h2>
        <p>The following items are not eligible for return or refund:</p>
        <div className="non-returnable-box">
          <ul>
            <li>Custom-made or made-to-order products (e.g., bespoke furniture, fitted wardrobes, gypsum installations)</li>
            <li>Installed or used products</li>
            <li>Clearance or discounted items marked as "Final Sale"</li>
            <li>Perishable or consumable goods (if applicable)</li>
            <li>Gift cards or vouchers</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>3. Return Process</h2>
        <p>To initiate a return:</p>
        <div className="process-steps">
          <h3>Contact us via:</h3>
          <ul>
            <li>Email: techieinteriors@gmail.com</li>
            <li>Phone: +254748600208</li>
          </ul>
          <h3>Provide:</h3>
          <ul>
            <li>Order number</li>
            <li>Product details</li>
            <li>Reason for return</li>
            <li>Supporting images (if damaged/defective)</li>
          </ul>
        </div>

        <h3>Once approved:</h3>
        <div className="approval-process">
          <ul>
            <li>You will receive return instructions</li>
            <li>Items must be shipped or delivered within 7 days after approval</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>4. Return Shipping</h2>
        <p>Customers are responsible for return shipping costs, unless:</p>
        <ul>
          <li>The item is defective</li>
          <li>The wrong item was delivered</li>
        </ul>
        <div className="shipping-responsibility">
          <p><strong>Techie Interiors is not responsible for:</strong></p>
          <ul>
            <li>Lost or damaged return shipments</li>
            <li>Delays caused by third-party couriers</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>5. Inspection & Approval</h2>
        <p>All returned items will be inspected upon receipt:</p>
        <div className="inspection-box">
          <ul>
            <li><strong>If approved →</strong> refund/exchange processed</li>
            <li><strong>If rejected →</strong> item returned to customer at their cost</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>6. Refund Policy</h2>
        
        <h3>Eligible Refunds</h3>
        <p>Refunds will be issued if:</p>
        <div className="refund-eligibility">
          <ul>
            <li>Item is defective or damaged</li>
            <li>Wrong item was delivered</li>
            <li>Order was canceled before dispatch</li>
          </ul>
        </div>

        <h3>Refund Method</h3>
        <div className="refund-method-box">
          <ul>
            <li>Refunds will be processed via the original payment method</li>
            <li>Mobile money, bank transfer, or card reversal depending on payment used</li>
          </ul>
        </div>

        <h3>Processing Time</h3>
        <div className="processing-time">
          <ul>
            <li>Refunds are processed within 7–14 business days after approval</li>
            <li>Additional delays may occur depending on banks or payment providers</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>7. Exchanges</h2>
        <p>We only replace items if:</p>
        <div className="exchange-conditions">
          <ul>
            <li>They are defective or damaged</li>
            <li>The wrong item was delivered</li>
          </ul>
        </div>

        <p>If you need an exchange:</p>
        <ul>
          <li>Contact support within 14 days</li>
          <li>Exchange is subject to stock availability</li>
        </ul>
      </div>

      <div className="return-refund-section">
        <h2>8. Damaged or Defective Products</h2>
        <p>If you receive a damaged or defective item:</p>
        <div className="defective-report-box">
          <ul>
            <li>Report within 48 hours of delivery</li>
            <li>Provide clear photos/videos as evidence</li>
          </ul>
        </div>

        <p>Techie Interiors will:</p>
        <ul>
          <li>Replace the item, or</li>
          <li>Offer a full/partial refund</li>
        </ul>

        <div className="urgent-notice">
          <p>
            <strong>Important:</strong> Failure to report within this period may result in rejection of the claim.
          </p>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>9. Order Cancellation</h2>
        <div className="cancellation-policy">
          <ul>
            <li>Orders can be canceled before dispatch for a full refund</li>
            <li>Once dispatched:
              <ul>
                <li>Cancellation is treated as a return</li>
                <li>Return shipping costs may apply</li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>10. Late or Missing Refunds</h2>
        <p>If you haven't received your refund:</p>
        <div className="late-refund-steps">
          <ol>
            <li>Check your bank account</li>
            <li>Contact your payment provider</li>
            <li>Contact us at techieinteriors@gmail.com</li>
          </ol>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>11. Installation Services & Returns</h2>
        <p>
          For products that include installation (e.g., gypsum ceilings, TV wall units, wardrobes):
        </p>
        <div className="installation-notice">
          <ul>
            <li>Returns are not applicable once installation is completed</li>
            <li>Issues must be reported within 48 hours of installation</li>
            <li>Warranty terms may apply instead</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>12. Warranty (If Applicable)</h2>
        <p>Certain products may come with a warranty:</p>
        <div className="warranty-box">
          <ul>
            <li>Covers manufacturing defects only</li>
            <li>Does not cover misuse, wear and tear, or improper installation by third parties</li>
            <li>Warranty terms will be provided per product</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>13. Fraud Prevention</h2>
        <p>Techie Interiors reserves the right to:</p>
        <div className="fraud-prevention">
          <ul>
            <li>Refuse returns suspected of abuse or fraud</li>
            <li>Request identity verification for high-value refunds</li>
          </ul>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>14. Contact Us</h2>
        <p>For all return and refund inquiries:</p>
        <div className="contact-info-box">
          <p><strong>Techie Interiors</strong></p>
          <p>Email: techieinteriors@gmail.com</p>
          <p>Phone: +254748600208</p>
          <p>Address: Corner A Githunguri, Ruiru, Kenya</p>
        </div>
      </div>

      <div className="return-refund-section">
        <h2>15. Policy Updates</h2>
        <div className="policy-update-notice">
          <p>
            Techie Interiors reserves the right to modify this policy at any time. Updates will be posted on this page with a revised effective date.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReturnAndRefund;